import React from 'react';
import { Container } from 'reactstrap';
import classnames from 'classnames';

import { Intl } from 'components';

export default ( { error, isLoading } ) => (
  <Container
    fluid
    className={classnames( 'mt-4', { 'app-component-loading': isLoading } )}
  >
    {!error ? 'Wait...' : (
      <span className="invalid-feedback d-block text-md">
        <Intl id={error} />
      </span>
    )}
  </Container>
);
